import { useEffect, useState } from 'react';
import Grid, { GridColumn, GridHeader, GridRow } from "../Grid/Grid";
import { Card } from "react-bootstrap";
import HelperService from '../utility/HelperService';

interface propData {
    data: any
}

const headers: GridHeader[] = [
    {
        title: "Tech Name",
        class: 'text-center',
    },
    {
        title: "Service Date",
        class: 'text-center',
    },
    {
        title: "Tech Time",
        class: 'text-center'
    },
    {
        title: "Work Signature",
        class: 'text-center'
    },
];

const InvoiceDetailTechnician = (props: propData) => {
    const [rows, setRows] = useState<GridRow[]>([]);

    useEffect(() => {
        getTechnician()
    }, [props.data.techList])

    const getTechnician = () => {
        if (props.data.techList && props.data.techList.length > 0) {
            let rows: GridRow[] = [];
            for (var i in props.data.techList) {
                let columns: GridColumn[] = [];
                columns.push({ value: props.data.techList[i].techName });
                columns.push({ value: props.data.techList[i].servDate && HelperService.getFormatedDate(props.data.techList[i].servDate) });
                columns.push({ value: props.data.techList[i].techtime });
                columns.push({ value: renderSignature(props.data.techList[i]) });
                rows.push({ data: columns });
            }
            setRows(rows);
        }
    }

    const renderSignature = (data: any) => {
        return (
            <div>
                {data.workSignature && <img src={`data:image/png;base64,${data.workSignature}`} style={{ height: 100, width: 200 }} />}
                <div style={{ marginRight: 50, }}>
                    {data.signedBy && <div>{data.signedBy}</div>}
                    {data.signedOn && <div>{HelperService.getFormatedDateAndTime(data.signedOn)}</div>}
                </div>
            </div>
        )
    }

    return (
        <>
            <Card className="card-style form-style invoice-call-picture-card" style={{ marginBottom: 50 }}>
                <Grid
                    headers={headers}
                    rows={rows}
                    ShowLoader={false}
                    errorMessage={'No Technician Available'} />
            </Card>
        </>
    )
}

export default InvoiceDetailTechnician;